
import { defineComponent, ref } from 'vue';
import ModalLayout from '@/layouts/ModalLayout.vue';
import { Invite } from '@/data/models/Invite';
import InviteElement from '@/components/InviteElement.vue';

export default defineComponent({
  props: {
    invites: {
      type: Object as () => Invite[],
      required: true,
    },
    hasTeam: {
      type: Boolean,
      required: true,
    },
    refreshHomePage: {
      type: Function,
      required: true,
    },
  },

  setup() {
    const error = ref<string | undefined>();

    const changeError = (newError: string) => {
      error.value = newError;
    };

    return {
      changeError,
      error,
    };
  },

  components: { InviteElement, ModalLayout },
});
